import { Flag } from "./Flag";

interface FlagHoistProps {
  /// Flag characters in hoist order (top to bottom).
  flags: readonly string[];
  /// Per-flag pixel size. Default 96.
  size?: number;
}

/// Vertical stack of ICS flags as flown on a single halyard. The
/// receiver reads top-to-bottom — that's the convention the
/// International Code of Signals uses. A small visual gap between
/// flags makes them readable without looking like a single
/// composite design.
export function FlagHoist({ flags, size = 96 }: FlagHoistProps) {
  const description = `Flag hoist: ${flags.join(" over ")}`;
  return (
    <div
      role="img"
      aria-label={description}
      style={{
        display: "inline-flex",
        flexDirection: "column",
        gap: 6,
        alignItems: "center",
      }}
    >
      {flags.map((c, i) => (
        <Flag key={`${i}-${c}`} char={c} size={size} />
      ))}
    </div>
  );
}
